/**
 * @generated SignedSource<<49d66ab7811a0d279743df80d01bf1cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatePersonalStreamInput = {
  clientMutationId?: string | null;
  createNote?: boolean | null;
  description: string;
  groupId?: string | null;
  name: string;
  shareWith?: ReadonlyArray<string> | null;
};
export type CreateStreamModalMutation$variables = {
  input: CreatePersonalStreamInput;
};
export type CreateStreamModalMutation$data = {
  readonly createPersonalStream: {
    readonly homePanelGroup: {
      readonly " $fragmentSpreads": FragmentRefs<"HomePanelGroup_group">;
    } | null;
    readonly stream: {
      readonly id: string;
    };
  } | null;
};
export type CreateStreamModalMutation = {
  response: CreateStreamModalMutation$data;
  variables: CreateStreamModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStream",
  "kind": "LinkedField",
  "name": "stream",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "image",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isActive",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isConfigured",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasReceivedInvites",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "relationshipToViewer",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isGuest",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isTopUser",
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "onlyReportManager",
        "value": true
      }
    ],
    "concreteType": "Event",
    "kind": "LinkedField",
    "name": "activeRecurring1on1Event",
    "plural": false,
    "selections": (v3/*: any*/),
    "storageKey": "activeRecurring1on1Event(onlyReportManager:true)"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "HomePanelGroup",
  "kind": "LinkedField",
  "name": "homePanelGroup",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willBeRecorded",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAllDay",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeBlockType",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "ConferenceCall",
  "kind": "LinkedField",
  "name": "conferenceCalls",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    },
    (v8/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Calendar",
  "kind": "LinkedField",
  "name": "calendar",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HomePanelGroup",
      "kind": "LinkedField",
      "name": "homePanelGroup",
      "plural": false,
      "selections": [
        (v6/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "HomePanelObjectInterface",
  "abstractKey": "__isHomePanelObjectInterface"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateStreamModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreatePersonalStreamPayload",
        "kind": "LinkedField",
        "name": "createPersonalStream",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HomePanelGroup",
            "kind": "LinkedField",
            "name": "homePanelGroup",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HomePanelGroup_group"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateStreamModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreatePersonalStreamPayload",
        "kind": "LinkedField",
        "name": "createPersonalStream",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HomePanelGroup",
            "kind": "LinkedField",
            "name": "homePanelGroup",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emojiName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HomePanelObjectsConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HomePanelObjectsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v7/*: any*/),
                            "type": "User",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "userCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerLastSeenAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "latestNoteEditedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isExternal",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasExternalUsers",
                                "storageKey": null
                              },
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "otherUser",
                                "plural": false,
                                "selections": (v7/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "linkedEvent",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "nextOccurrence",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "end",
                                        "storageKey": null
                                      },
                                      (v2/*: any*/),
                                      (v10/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "finalOccurrence",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Note",
                                "kind": "LinkedField",
                                "name": "latestNote",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "eventStart",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "eventEnd",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "finished",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "event",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v10/*: any*/),
                                      (v12/*: any*/),
                                      (v11/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NoteStreamPublicLink",
                                "kind": "LinkedField",
                                "name": "publicLink",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "enabled",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "archived",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "starred",
                                "storageKey": null
                              },
                              (v18/*: any*/)
                            ],
                            "type": "NoteStream",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "label",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "color",
                                "storageKey": null
                              },
                              (v9/*: any*/),
                              (v18/*: any*/)
                            ],
                            "type": "Tag",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v3/*: any*/),
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c27821e8a33413e7ff9df5ea1c1090da",
    "id": null,
    "metadata": {},
    "name": "CreateStreamModalMutation",
    "operationKind": "mutation",
    "text": "mutation CreateStreamModalMutation(\n  $input: CreatePersonalStreamInput!\n) {\n  createPersonalStream(input: $input) {\n    stream {\n      id\n    }\n    homePanelGroup {\n      ...HomePanelGroup_group\n      id\n    }\n  }\n}\n\nfragment GroupsMenu_stream on NoteStream {\n  ...HomePanelGroupsMenu_object\n  id\n  homePanelGroup {\n    id\n  }\n}\n\nfragment HomePanelGroup_group on HomePanelGroup {\n  id\n  type\n  name\n  emojiName\n  items {\n    edges {\n      node {\n        __typename\n        ... on User {\n          id\n          ...OneOnOneLink_user\n        }\n        ... on NoteStream {\n          ...StreamLink_stream\n          id\n          archived\n          starred\n          viewerLastSeenAt\n          latestNoteEditedAt\n        }\n        ... on Tag {\n          __typename\n          id\n          label\n          color\n          ...TagLink_tag\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment HomePanelGroupsMenu_object on HomePanelObjectInterface {\n  __isHomePanelObjectInterface: __typename\n  id\n  __typename\n  ... on NoteStream {\n    type\n  }\n  homePanelGroup {\n    id\n    name\n  }\n}\n\nfragment OneOnOneLink_user on User {\n  id\n  fullName\n  image\n  isActive\n  isConfigured\n  email\n  hasReceivedInvites\n  relationshipToViewer\n  isGuest\n  isTopUser\n  activeRecurring1on1Event(onlyReportManager: true) {\n    id\n  }\n}\n\nfragment RecordIcon_event on Event {\n  id\n  guid\n  willBeRecorded\n  start\n  status\n  isAllDay\n  timeBlockType\n  conferenceCalls {\n    provider\n    url\n  }\n  calendar {\n    id\n  }\n}\n\nfragment StreamLink_stream on NoteStream {\n  id\n  type\n  url\n  displayName\n  userCount\n  viewerLastSeenAt\n  latestNoteEditedAt\n  isExternal\n  hasExternalUsers\n  ...GroupsMenu_stream\n  otherUser {\n    ...OneOnOneLink_user\n    id\n  }\n  linkedEvent {\n    id\n    guid\n    nextOccurrence {\n      start\n      end\n      ...RecordIcon_event\n      id\n    }\n    finalOccurrence\n  }\n  latestNote {\n    id\n    eventStart\n    eventEnd\n    finished\n    event {\n      id\n      guid\n      ...RecordIcon_event\n    }\n  }\n  publicLink {\n    enabled\n    id\n  }\n}\n\nfragment TagLink_tag on Tag {\n  id\n  label\n  color\n  homePanelGroup {\n    id\n  }\n  ...HomePanelGroupsMenu_object\n}\n"
  }
};
})();

(node as any).hash = "1e89a2e2322a9ddbe2eb480e7d1dabde";

export default node;
